export default __webpack_public_path__ + "static/01-d8bd45fdf2442d6da476c8081cd48531.png";